/**
 * Shared constants for the Recent Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full recentQueryConfig module (which contains heavy query-building logic,
 * data transforms, and GraphQL queries) into chunks that only need these
 * constants (e.g. the preloader). This prevents tree-shaking defeats.
 */

import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';

export enum ActivityEventType {
	ASSIGNED = 'ASSIGNED',
	COMMENTED = 'COMMENTED',
	CREATED = 'CREATED',
	EDITED = 'EDITED',
	LIKED = 'LIKED',
	PUBLISHED = 'PUBLISHED',
	SNAPSHOTTED = 'SNAPSHOTTED',
	STARTED = 'STARTED',
	TRANSITIONED = 'TRANSITIONED',
	UNASSIGNED = 'UNASSIGNED',
	UPDATED = 'UPDATED',
	VIEWED = 'VIEWED',
}

export enum ActivityObjectType {
	PAGE = 'PAGE',
	BLOGPOST = 'BLOGPOST',
	WHITEBOARD = 'WHITEBOARD',
	DATABASE = 'DATABASE',
	SLIDE = 'SLIDE',
	EMBED = 'EMBED',
	CONTENT = 'CONTENT',
	COMMENT = 'COMMENT',
}

export const PAGE_SIZE = 30;

/** Full set of activity object types; callers drop SLIDE when `confluence-slides` is off. */
export const OBJECT_TYPES: ActivityObjectType[] = [
	ActivityObjectType.PAGE,
	ActivityObjectType.BLOGPOST,
	ActivityObjectType.WHITEBOARD,
	ActivityObjectType.DATABASE,
	ActivityObjectType.SLIDE,
	ActivityObjectType.EMBED,
	ActivityObjectType.CONTENT,
];

/** Object types for recent activity queries, omitting {@link ActivityObjectType.SLIDE} when slides are disabled in this environment. */
export function objectTypes(): ActivityObjectType[] {
	return OBJECT_TYPES.filter(
		(t) => t !== ActivityObjectType.SLIDE || isContentTypeEnabledInCurrentEnv('slide'),
	);
}

export const WORKED_ON_EVENT_TYPES: ActivityEventType[] = [
	ActivityEventType.EDITED,
	ActivityEventType.PUBLISHED,
	ActivityEventType.UPDATED,
	ActivityEventType.CREATED,
	ActivityEventType.STARTED,
	ActivityEventType.SNAPSHOTTED,
];
